import { RootState } from 'store';

// Selectors, performing common selection tasks for this slice.
export const selectCareQualificationLevels = ({ appointments }: RootState) => appointments.careQualificationLevels.rows;
